var animPromise,
	ajaxPromise,
	pathArray = location.href.split("/"),
	protocol = pathArray[0],
	host = pathArray[2],
	ajax_url = protocol + "//" + host + "/wp-admin/admin-ajax.php",
	carSeatsPageLoadUpdate = false;

// custom function to AJAX delay the queries.
function wait() {
	var deferred = jQuery.Deferred();
	setTimeout(function () {
		deferred.resolve();
	}, 600);

	return deferred.promise();
}

// custom function to calculate the car model details and format it to be displayed as an input or textarea.
function formatCarModel(result, type = "textarea", looktype = "dynamic") {
	let carModel = "",
		gap = "</br>",
		dateParts,
		year = null,
		month = null,
		error = false;

	if (type == "input") {
		gap = ", ";
	}

	if (result !== null) {
		if (result.FirstRegistered) {
			// Split the dateString into year, month, and day components.
			dateParts = result.FirstRegistered.split("-");
			year = parseInt(dateParts[0]);
			month = parseInt(dateParts[1]);
			$(".quote-question.car__first_registered").addClass("quote-question--hidden");
		} else {
			$(".quote-question.car__first_registered").removeClass("quote-question--hidden");
			$(".quote-question.car__manual_car_registration").removeClass("quote-question--hidden");
		}

		if (result.Registration) {
			carModel = carModel + "Registration: " + result.Registration + gap;
			$(".quote-question.car__manual_car_registration").find("input").val(result.Registration);
		}

		if (result.MakeModel) {
			carModel += result.MakeModel + gap;

			if ($("#section-title--car").length) {
				$("#section-title--car").html(result.MakeModel);
			}
		}

		if(result.BodyStyle) {
			carModel += 'Body Style: ' + result.BodyStyle + gap;
		}

		if (result.Colour) {
			carModel += "Colour: " + result.Colour + gap;
		}

		if (year && month) {
			carModel += "Registered: " + month + "/" + year + gap;
		}

		if (result.NumberSeats) {
			carModel += "Seats: " + result.NumberSeats + gap;
		}

		if (result.CubicCapacity) {
			carModel += "Engine Size: " + result.CubicCapacity + gap;
		}

		if (result.GrossWeight) {
			carModel += "Weight: " + result.GrossWeight + gap;
		}

		if (result.FuelType) {
			carModel += "Fuel: " + result.FuelType + gap;
		}

		if (result.NumberOfDoors) {
			carModel += "Doors: " + result.NumberOfDoors + gap;
		}

		if (result.TransmissionType) {
			carModel += "Transmission: " + result.TransmissionType;

			var license_type = $("input[name=selected_license_type]").val();

			if (license_type == "automatic" && result.TransmissionType == "AUTOMATIC") {
				error = true;
			}
		}

		if (type == "textarea") {
			if (error) {
				carModel += '<div class="quote-tooltip__content error active"><span class="c__info error active"></span><div></div></div>';
				carModel += '<span id="car-incorrect">Change car details</span>';
			} else if (looktype == "manual") {
				if($('input[name="hide_new_questions"]').length && $('input[name="is_renewal"]').length) {
					if($('input[name="hide_new_questions"]').val() != 'false' && $('input[name="is_renewal"]').val() != 'true') {
						carModel += '<span id="car-incorrect-manual" tabindex="0">Not the right car?</span>';
					}
				} else {
					carModel += '<span id="car-incorrect-manual" tabindex="0">Not the right car?</span>';
				}
			} else {
				if($('input[name="hide_new_questions"]').length && $('input[name="is_renewal"]').length) {
					if($('input[name="hide_new_questions"]').val() != 'false' && $('input[name="is_renewal"]').val() != 'true') {
						carModel += '<span id="car-incorrect-manual" tabindex="0">Not the right car?</span>';
					}
				} else {
					carModel += '<span id="car-incorrect-manual" tabindex="0">Not the right car?</span>';
				}
			}
		}
	}

	return {
		data: carModel,
		error: error,
	};
}

// if a user clicks on the button to dynamically lookup their registration number.
function triggerDynamicCarRegLookup() {
	$(document).on("click", ".car__registration-find", function (e) {
		e.preventDefault();

		var parent = $(this).closest(".car__registration"),
			parentDynamic = parent.find(".car__registration-dynamic-wrapper"),
			carRegSearch = parent.find("input.car-registration"),
			resultTextarea = parent.find(".car__registration-result .textarea"),
			resultNotice = parent.find(".car__registration-notice"),
			resultInput = parent.find(".car__registration-result input"),
			carRegSelectionType = parentDynamic.find(".car__registration__selection-type"),
			result,
			carModel;

		parent.removeClass("error input-status input-status--incorrect input-status--correct");
		parent.find(".error-input").removeClass("error-input");
		carRegSelectionType.prop('checked', true);

		if (carRegSearch.val()) {
			// activate the spinner.
			parentDynamic.addClass("loading");

			animPromise = wait();
			ajaxPromise = $.ajax({
				type: "POST",
				url: ajax_url,
				dataType: "json",
				data: {
					action: "mw_ajax_car_reg_dynamic",
					reg: carRegSearch.val(),
				},
				success: function (data) {
					result = data;
				},
				error: function (xhr, status, error) {
					console.error("Error occurred during AJAX request - status code:", xhr.status);
					console.error("Error occurred during AJAX request - message:", error);

					parentDynamic.removeClass("loading");
					resultTextarea.html("");
					resultTextarea.removeClass("active");
					$(".quote-car").removeClass("active");
					$(".quote-error").removeClass("active");
					resultNotice.removeClass("active");
					parent.addClass("error");
				},
				complete: function () {
					window.mwConsoleLog("AJAX request complete.");
				},
			});
			$.when(animPromise, ajaxPromise).done(function () {
				let success = true;

				if (result && result != "[]" && result.length) {
					// eslint-disable-next-line
					let decodedResult = JSON.parse(result.replace(/\u0004/g, ""));
					if (decodedResult) {
						parent.removeClass("error input-status input-status--incorrect input-status--correct");
						parent.find(".error-input").removeClass("error-input");

						$.each(decodedResult, function (key, value) {
							if (key == "VehicleABIOptions") {
								if (value) {
									let selectAbi = parentDynamic.find(".car__registration-abi");

									selectAbi.find("option:not(:first)").remove();

									for (let i = 0; i < value.length; i++) {
										let abiNumber = value[i].match(/\[(.*?)\]/)[1],
											abiText = value[i],
											customOption = $("<option></option>").attr("value", abiNumber).text(abiText);

										selectAbi.append(customOption);
									}

									parentDynamic.removeClass("loading");
									selectAbi.addClass("active");

									selectAbi.select2({
										minimumResultsForSearch: 12,
									});

									selectAbi.on("change", function () {
										// activate the spinner.
										parentDynamic.addClass("loading");

										animPromise = wait();
										ajaxPromise = $.ajax({
											type: "POST",
											url: ajax_url,
											dataType: "json",
											data: {
												action: "mw_ajax_car_reg_dynamic",
												reg: carRegSearch.val(),
												abi: $(this).val(),
											},
											success: function (data) {
												result = data;
											},
											error: function (xhr, status, error) {
												console.error("Error occurred during AJAX request - status code:", xhr.status);
												console.error("Error occurred during AJAX request - message:", error);

												parentDynamic.removeClass("loading");
												resultTextarea.html("");
												resultTextarea.removeClass("active");
												$(".quote-car").removeClass("active");
												$(".quote-error").removeClass("active");
												resultNotice.removeClass("active");
												parent.addClass("error");
											},
											complete: function () {
												window.mwConsoleLog("AJAX request complete.");
											},
										});
										$.when(animPromise, ajaxPromise).done(function () {
											let success = true;

											if (result && result != "[]" && result.length) {
												// eslint-disable-next-line
												let decodedResult = JSON.parse(result.replace(/\u0004/g, ""));
												if (decodedResult) {
													parent.removeClass("error input-status input-status--incorrect input-status--correct");
													parent.find(".error-input").removeClass("error-input");

													$.each(decodedResult, function (key, value) {
														if (key == "Vehicle") {
															if (value) {
																// format the car model data accordingly as per an input field.
																carModel = formatCarModel(value);

																parentDynamic.removeClass("loading");
																resultTextarea.addClass("active");

																if (carModel.error) {
																	var errorMessage = resultTextarea.attr("data-error");

																	if (errorMessage) {
																		carModel.data = carModel.data.replace("<div></div>", "<div>" + errorMessage + "</div>");
																	}

																	$(".quote-error").addClass("active");
																} else {
																	$(".quote-car").addClass("active");
																}

																parentDynamic.removeClass("active");

																resultNotice.addClass("active");
																resultTextarea.html(carModel.data);
																resultInput.val(JSON.stringify(value));

																if ($("#car__seats").length) {
																	if($("#car__seats").val() && !carSeatsPageLoadUpdate) {
																		carSeatsPageLoadUpdate = true;
																	} else {
																		$("#car__seats").val(value.NumberSeats).trigger("change");
																	}
																}
															}
														}
													});
												} else {
													success = false;
												}
											} else {
												success = false;
											}

											// if the AJAX query wasn't successful, then show error.
											if (!success) {
												parentDynamic.removeClass("loading");
												resultTextarea.html("");
												resultTextarea.removeClass("active");
												$(".quote-car").removeClass("active");
												$(".quote-error").removeClass("active");
												resultNotice.removeClass("active");
												parent.addClass("error");
											}
										});
									});
								}
							} else if (key == "Vehicle") {
								if (value) {
									// format the car model data accordingly as per an input field.
									carModel = formatCarModel(value);

									parentDynamic.removeClass("loading");
									resultTextarea.addClass("active");

									if (carModel.error) {
										var errorMessage = resultTextarea.attr("data-error");

										if (errorMessage) {
											carModel.data = carModel.data.replace("<div></div>", "<div>" + errorMessage + "</div>");
										}

										$(".quote-error").addClass("active");
									} else {
										$(".quote-car").addClass("active");
									}

									parentDynamic.removeClass("active");

									resultNotice.addClass("active");
									resultTextarea.html(carModel.data);
									resultInput.val(JSON.stringify(value));

									if ($("#car__seats").length) {
										if($("#car__seats").val() && !carSeatsPageLoadUpdate) {
											carSeatsPageLoadUpdate = true;
										} else {
											$("#car__seats").val(value.NumberSeats).trigger("change");
										}
									}
								}
							}
						});
					} else {
						success = false;
					}
				} else {
					success = false;
				}

				// if the AJAX query wasn't successful, then show error.
				if (!success) {
					parentDynamic.removeClass("loading");
					resultTextarea.html("");
					resultTextarea.removeClass("active");
					$(".quote-car").removeClass("active");
					$(".quote-error").removeClass("active");
					resultNotice.removeClass("active");
					parent.addClass("error");
				}
			});
		} else {
			parent.addClass("error");
		}
	});
}

// if a user clicks on the button to manually lookup their registration number.
function triggerManualCarRegLookup() {
	$(document).on("click", ".car__registration-find-manually", function (e) {
		e.preventDefault();

		var parent = $(this).closest(".car__registration"),
			parentManual = parent.find(".car__registration-manual-wrapper"),
			makeModel = parent.find(".car__make_model--input"),
			transmission = parent.find(".car__transmission_type--input"),
			fuel = parent.find(".car__fuel_type--input"),
			resultTextarea = parent.find(".car__registration-result .textarea"),
			resultNotice = parent.find(".car__registration-notice"),
			resultInput = parent.find(".car__registration-result input"),
			carRegSelect = parent.find(".car__registration-manual-results"),
			carRegSelectParent = parent.find(".car__registration-searchResults"),
			carRegSelectionType = parentManual.find(".car__registration__selection-type"),
			result;

		parent.removeClass("error input-status input-status--incorrect input-status--correct");
		parent.find(".error-input").removeClass("error-input");
		carRegSelectionType.prop('checked', true);

		if (makeModel.val() && transmission.val() && fuel.val()) {
			// activate the spinner.
			parentManual.addClass("loading");

			animPromise = wait();
			ajaxPromise = $.ajax({
				type: "POST",
				url: ajax_url,
				dataType: "json",
				data: {
					action: "mw_ajax_car_reg_manual",
					makeModel: makeModel.val().toUpperCase(),
					transmission: transmission.val(),
					fuel: fuel.val(),
				},
				success: function (data) {
					result = data;
				},
				error: function (xhr, status, error) {
					console.error("Error occurred during AJAX request - status code:", xhr.status);
					console.error("Error occurred during AJAX request - message:", error);

					parentManual.removeClass("loading");
					resultTextarea.html("");
					resultTextarea.removeClass("active");
					$(".quote-car").removeClass("active");
					$(".quote-error").removeClass("active");
					resultNotice.removeClass("active");
					parent.addClass("error");
				},
				complete: function () {
					window.mwConsoleLog("AJAX request complete.");
				},
			});
			$.when(animPromise, ajaxPromise).done(function () {
				let success = true;

				if (result && result != "[]") {
					// eslint-disable-next-line
					let decodedResult = JSON.parse(result.replace(/\u0004/g, ""));
					if (decodedResult) {
						parent.removeClass("error input-status input-status--incorrect input-status--correct");
						parent.find(".error-input").removeClass("error-input");

						carRegSelect.html("<option value='' disabled selected='selected'> - Select - </option>");

						// eslint-disable-next-line
						$.each(decodedResult, function (key, value) {
							// format the car model data accordingly as per an input field.
							let formattedCarModel = formatCarModel(value, "input");

							if (formattedCarModel.data) {
								carRegSelect.append("<option value='" + JSON.stringify(value) + "' data-key=" + key + ">" + formattedCarModel.data + "</option>");
							}
						});

						$(carRegSelect).select2({
							minimumResultsForSearch: 7,
						});

						parentManual.removeClass("loading");
						carRegSelect.trigger("change");
						carRegSelectParent.addClass("active");

						resultTextarea.removeClass("active");
						$(".quote-car").removeClass("active");
						$(".quote-error").removeClass("active");
						resultNotice.removeClass("active");
						resultTextarea.html("");
						resultInput.val("");
					} else {
						success = false;
					}
				} else {
					success = false;
				}

				// if the AJAX query wasn't successful, then show error.
				if (!success) {
					parentManual.removeClass("loading");
					carRegSelectParent.removeClass("active");
					carRegSelect.html("<option value='' disabled selected='selected'> - Select - </option>");
					resultTextarea.removeClass("active");
					$(".quote-car").removeClass("active");
					$(".quote-error").removeClass("active");
					resultNotice.removeClass("active");
					resultTextarea.html("");
					parent.addClass("error");
				}
			});
		} else {
			parent.addClass("error");
		}
	});
}

// if the user switches from manual/dynamic car lookup.
function switchCarRegLookup() {
	$(document).on("click", ".car__registration-dynamic", function (e) {
		e.preventDefault();

		let parent = $(this).closest(".car__registration");

		parent.removeClass("error input-status input-status--incorrect input-status--correct");
		parent.find(".error-input").removeClass("error-input");

		parent.addClass("dynamic").removeClass("manual");
		parent.find(".car__make_model").val("");
		parent.find(".car__transmission_type").val("");
		parent.find(".car__fuel_type").val("");
		parent.find(".car__registration-manual-results").val("");
		parent.find(".car__registration-searchResults").removeClass("active");
		parent.find(".car__registration-result .textarea").html("");
		parent.find(".car__registration-result .textarea").removeClass("active");
		parent.find(".car__registration-notice").removeClass("active");
		parent.find(".car__registration-dynamic-wrapper").addClass("active");
		parent.find(".car__registration-manual-wrapper").removeClass("active");
		$(".quote-question.car__first_registered").addClass("quote-question--hidden");
		$(".quote-question.car__manual_car_registration").addClass("quote-question--hidden");
		$(".quote-car").removeClass("active");
		$(".quote-error").removeClass("active");

		parent.find(".car__registration-manual-wrapper").children('.quote-question').find('input[type="text"], input[type="number"], input[type="date"], input[type="datetime-local"], input[type="password"], button.quote-question__boolean-btn, a, select:not(.select2-hidden-accessible), textarea, .select2-selection, .c__info-tooltip').attr('tabindex', '-1');
		parent.find(".car__registration-dynamic-wrapper").children('.quote-question').find('input[type="text"], input[type="number"], input[type="date"], input[type="datetime-local"], input[type="password"], button.quote-question__boolean-btn, a, select:not(.select2-hidden-accessible), textarea, .select2-selection, .c__info-tooltip').attr('tabindex', '0');
		toggleSelect2TabIndex();
	});

	$(document).on("click", ".car__registration-manual", function (e) {
		e.preventDefault();

		let parent = $(this).closest(".car__registration");

		parent.removeClass("error input-status input-status--incorrect input-status--correct");
		parent.find(".error-input").removeClass("error-input");

		parent.addClass("manual").removeClass("dynamic");
		parent.find("input.car-registration").val("");
		parent.find(".car__registration-result .textarea").html("");
		parent.find(".car__registration-result .textarea").removeClass("active");
		parent.find(".car__registration-notice").removeClass("active");
		parent.find(".car__registration-dynamic-wrapper").removeClass("active");
		parent.find(".car__registration-manual-wrapper").addClass("active");
		$(".quote-car").removeClass("active");
		$(".quote-error").removeClass("active");

		parent.find(".car__registration-manual-wrapper").children('.quote-question').find('input[type="text"], input[type="number"], input[type="date"], input[type="datetime-local"], input[type="password"], button.quote-question__boolean-btn, a, select:not(.select2-hidden-accessible), textarea, .select2-selection, .c__info-tooltip').attr('tabindex', '0');
		parent.find(".car__registration-dynamic-wrapper").children('.quote-question').find('input[type="text"], input[type="number"], input[type="date"], input[type="datetime-local"], input[type="password"], button.quote-question__boolean-btn, a, select:not(.select2-hidden-accessible), textarea, .select2-selection, .c__info-tooltip').attr('tabindex', '-1');
		toggleSelect2TabIndex();
	});
}

// if the user selects a specific version when doing the manual car lookup.
function selectManualCarRegLookup() {
	$(document).on("change", ".car__registration-manual-results", function (e) {
		e.preventDefault();

		let parent = $(this).closest(".car__registration"),
			data = $(this).val(),
			resultTextarea = parent.find(".car__registration-result .textarea"),
			resultNotice = parent.find(".car__registration-notice"),
			resultInput = parent.find(".car__registration-result input"),
			formattedData;

		// format the car model data accordingly as per a textarea field.
		formattedData = formatCarModel(JSON.parse(data), "textarea", "manual");

		resultInput.val(data);
		if (formattedData.error) {
			var errorMessage = resultTextarea.attr("data-error");

			if (errorMessage) {
				formattedData.data = formattedData.data.replace("<div></div>", "<div>" + errorMessage + "</div>");
			}

			$(".quote-error").addClass("active");
		} else {
			$(".quote-car").addClass("active");
		}

		resultTextarea.html(formattedData.data);
		resultTextarea.addClass("active");
		+"";
		resultNotice.addClass("active");
	});
}

// on selection of not the right car - fall back.
function triggerCarRegIncorrect() {
	$(document).on("click", "#car-incorrect", function (e) {
		e.preventDefault();

		var parent = $(this).closest(".car__registration"),
			parentDynamic = parent.find(".car__registration-dynamic-wrapper"),
			resultTextarea = parent.find(".car__registration-result .textarea"),
			resultNotice = parent.find(".car__registration-notice");

		parentDynamic.addClass("active");
		resultTextarea.html("");
		resultTextarea.removeClass("active");
		$(".quote-car").removeClass("active");
		$(".quote-error").removeClass("active");
		resultNotice.removeClass("active");
		parent.removeClass("error input-status input-status--incorrect input-status--correct");
		parent.find(".error-input").removeClass("error-input");
	});

	$(document).on("click", "#car-incorrect-manual", function (e) {
		e.preventDefault();

		var parent = $(this).closest(".car__registration"),
			parentManual = parent.find(".car__registration-manual-wrapper"),
			resultTextarea = parent.find(".car__registration-result .textarea"),
			resultNotice = parent.find(".car__registration-notice");

		parentManual.addClass("active");
		resultTextarea.html("");
		resultTextarea.removeClass("active");
		$(".quote-car").removeClass("active");
		$(".quote-error").removeClass("active");
		resultNotice.removeClass("active");
		parent.removeClass("error input-status input-status--incorrect input-status--correct");
		parent.find(".error-input").removeClass("error-input");
	});
}

// add custom functionality to not require license number if customer doesn't have one.
function skipRequireLicenceNumber() {
    if($('.license-number-none').length) {
        $(".license-number-none").on("change", function (e) {
            e.preventDefault();
    
            var parent = $(this).closest(".quote-question"),
                first = parent.find(".license-first"),
                second = parent.find(".license-second"),
                third = parent.find(".license-third"),
                none = parent.find(".license-number-none");
    
            if ($(this).prop("checked")) {
                none.removeAttr("value").attr("value", "true").prop("checked", true);
    
                first.removeClass("error-input").addClass("disabled");
                first.attr("data-required", "false");
                first.prop("disabled", true);
                first.removeAttr("value").attr("value", "").val("").trigger("change");
    
                second.removeClass("error-input").addClass("disabled");
                second.attr("data-required", "false");
                second.prop("disabled", true);
                second.removeAttr("value").attr("value", "").val("").trigger("change");
    
                third.removeClass("error-input").addClass("disabled");
                third.attr("data-required", "false");
                third.prop("disabled", true);
                third.removeAttr("value").attr("value", "").val("").trigger("change");
    
                parent.removeClass("input-status--incorrect").addClass("input-status--correct");
                parent.find(".validation_error").css("display", "none");
            } else {
                none.removeAttr("value").attr("value", "false").removeAttr("checked");
    
                first.removeClass("disabled");
                first.attr("data-required", "true");
                first.prop("disabled", false);
    
                second.removeClass("disabled");
                second.attr("data-required", "true");
                second.prop("disabled", false);
    
                third.removeClass("disabled");
                third.attr("data-required", "true");
                third.prop("disabled", false);
    
                parent.find(".validation_error").css("display", "");
            }
        });
    }
}

// CRO variation (convert_testing): gate the licence inputs behind a Yes/No radio.
function toggleLicenceProvideChoice() {
    if (!$('.license-provide-choice').length) {
        return;
    }

    function applyLicenceChoice($radio) {
        var parent = $radio.closest(".quote-question"),
            wrap = parent.find(".quote-question__license-inputs-wrap"),
            inputs = wrap.find('input[data-license-number="true"]'),
            noneHidden = parent.find(".license-number-none-hidden");

        if ($radio.hasClass("license-provide-yes")) {
            // Reveal the inputs and require them.
            wrap.removeAttr("hidden");
            inputs.removeClass("disabled").prop("disabled", false).attr("data-required", "true");
            noneHidden.val("false");
            parent.removeClass("input-status--correct input-status--incorrect");
            parent.find(".validation_error").css("display", "");

            // Re-wire the dynamic licence-number lookup (exposed by quote.js on window).
            // Safe to call repeatedly: quote.js binds these listeners with a namespace.
            if (typeof window.triggerNewLicenseNumber === "function") {
                window.triggerNewLicenseNumber();
            }

            // Populate the number straight away from the already-entered name/DOB.
            // directParent = true so the licence question itself is used as the target.
            if (typeof window.calculateLicenceNumber === "function") {
                window.calculateLicenceNumber(parent, true, "", true);
            }
        } else {
            // Hide, clear and un-require the inputs; flag the skip for the backend.
            wrap.attr("hidden", "hidden");
            inputs.removeClass("error-input disabled").attr("data-required", "false");
            inputs.prop("disabled", true).val("").trigger("change");
            parent.removeClass("show-placeholder");
            noneHidden.val("true");
            parent.removeClass("input-status--incorrect").addClass("input-status--correct");
            parent.find(".validation_error").css("display", "none");
        }
    }

    // Sync any pre-selected choice on load (e.g. prefilled quotes).
    $(".license-provide-choice input[type=radio]:checked").each(function () {
        applyLicenceChoice($(this));
    });

    $(document).on("change", ".license-provide-yes, .license-provide-no", function () {
        if ($(this).prop("checked")) {
            applyLicenceChoice($(this));
        }
    });
}

// If the user has typed in their car reg number, then also prefill it for the other [Car Registration] input.
function switchCarRegPrefill() {
    if($('input.car-registration').length && $('input.car-registration').val()) {
		let carRegManual = $("input[name=car__manual_car_registration]");

		carRegManual.val($('input.car-registration').val()).trigger("change");
    }

    $(document).on("change", "input.car-registration", function (e) {
		let carRegManual = $("input[name=car__manual_car_registration]");

		if ($(this).val().length > 0) {
			carRegManual.val($(this).val()).trigger("change");
		}
	});
}

// Dynamically trigger the car lookup if there's a Car Reg prefilled in.
function triggerCarRegLookup() {
    if($('.car-registration').length) {
        $(".car-registration").each(function () {
            if ($(this).val()) {
                wait();
                $(this).siblings(".car__registration-find").trigger("click");
				$(this).closest('.quote-question').children('.quote-question').find('input[type="text"], input[type="number"], input[type="date"], input[type="datetime-local"], input[type="password"], button.quote-question__boolean-btn, a, select:not(.select2-hidden-accessible), textarea, .select2-selection, .c__info-tooltip').attr('tabindex', -1);
            }
        });
    }
}

function toggleSelect2TabIndex() {
	setTimeout(function() {
		$('.select2[tabindex="-1"]').each(function() {
			$(this).find('.select2-selection').attr('tabindex', -1);
		});
	}, 500);
}

$(function () {
	// if a user clicks on the button to dynamically lookup their registration number.
	triggerDynamicCarRegLookup();

	// if a user clicks on the button to manually lookup their registration number.
	triggerManualCarRegLookup();

	// if the user switches from manual/dynamic car lookup.
	switchCarRegLookup();

    // If the user has typed in their car reg number, then also prefill it for the other [Car Registration] input.
    switchCarRegPrefill();

	// if the user selects a specific version when doing the manual car lookup.
	selectManualCarRegLookup();

	// on selection of not the right car - fall back
	triggerCarRegIncorrect();

	// add custom functionality to not require license number if customer doesn't have one.
	skipRequireLicenceNumber();

	// CRO variation: gate the licence inputs behind a Yes/No radio.
	toggleLicenceProvideChoice();

    // Dynamically trigger the car lookup if there's a Car Reg prefilled in.
    triggerCarRegLookup();
});
